const IconYoutube = (props) => {
    const color = props?.color || '#222222';

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.9177 5.08203C20.7691 5.08203 22.2615 6.71954 22.2615 8.7334V15.2656C22.269 17.2877 20.7691 18.917 18.9177 18.917H5.08179C3.23051 18.9169 1.73901 17.2794 1.73901 15.2656V8.7334C1.73901 6.71139 3.23801 5.0821 5.08179 5.08203H18.9177ZM9.80737 15.2529L15.6277 11.8965L9.80737 8.54102V15.2529Z" fill={color}/>
        </svg>
    );
};

export default IconYoutube;
